import {signal, WritableSignal} from '@angular/core';

export const navigatorScrollingSignal: WritableSignal<boolean> = signal<boolean>(false);
